import Backbone from 'lib/backbone';
import FieldView from 'app/views/FieldView';
import invokeCallbacks from 'app/NVTagCallbacks';

var $ = Backbone.$;
var _ = Backbone._;

export default FieldView.extend({
  __name__: 'BonusGiftView',
  type: 'bonus_gift',
  tagName: 'div',
  className: 'at-bonus-gift',
  events: {
    'change input[name="bonus-gift"]': 'onBonusGiftToggled',
    'change .bonus-gift-variant-select': 'onVariantSelected'
  },
  initialize: function () {
    FieldView.prototype.initialize.call(this);
    this.gift = (this.def.gifts && this.def.gifts[0]) || {};
    this.isChecked = false;
    this.selectedVariantOptionId = null;
  },
  context: function () {
    var self = this;
    var gift = _.extend({}, this.gift);

    if (this.isChecked) {
      gift.checked = 'checked';
    }

    if (gift.variants) {
      gift.variants = _.map(gift.variants, function (variant) {
        var mappedVariant = _.extend({}, variant);
        mappedVariant.options = _.map(variant.options, function (option) {
          var mappedOption = _.extend({}, option);
          if (option.availability === 'Backordered') {
            mappedOption.isBackordered = true;
          }
          if (option.availability === 'SoldOut') {
            mappedOption.isSoldOut = true;
          }
          return mappedOption;
        });
        mappedVariant.selectPlaceholder = self.resources.fill(
            self.resources.PrimaryResources.SelectAVariantOption, variant.name);
        return mappedVariant;
      });
    }

    if (!(gift.variants && gift.variants.length) && gift.availability === 'Backordered') {
      gift.backorderedMessage = this.resources.PrimaryResources.BackorderedMessage;
    }

    var context = {
      heading: this.resources.PrimaryResources.BonusGiftHeading,
      subheading: this.resources.PrimaryResources.BonusGiftNoMinimum,
      gift: gift
    };

    return invokeCallbacks('alterContext', { element: this.type, context: context, def: this.def }).context;
  },
  render: function () {
    var self = this;
    this.$el.html(this.template(this.context()));

    this.$('.gift-img-container').each(function (index, container) {
      var img = $(container).find('.gift-img img');
      $(img).one('load', function () {
        $(container).css('background-image', 'none');
      });
    });

    if (this.selectedVariantOptionId) {
      this.$('.bonus-gift-variant-select').each(function () {
        var $select = $(this);
        if ($select.find('option[value="' + self.selectedVariantOptionId + '"]').length) {
          $select.val(self.selectedVariantOptionId);
        }
      });
    }

    return this;
  },
  multiple_fields: function () {
    return ['BonusPremiumGift', 'BonusPremiumGiftVariantOptionId'];
  },
  isRequired: function () {
    return false;
  },
  isBonusSelected: function () {
    return this.isChecked;
  },
  getGift: function () {
    return this.gift;
  },
  hasVariants: function () {
    return !!(this.gift.variants && this.gift.variants.length);
  },
  val: function () {
    if (!this.isChecked) {
      return null;
    }
    var result = { BonusPremiumGift: this.gift.val };
    if (this.hasVariants()) {
      result.BonusPremiumGiftVariantOptionId = this.selectedVariantOptionId || null;
    }
    return result;
  },
  setval: function (values) {
    if (!values || !values.BonusPremiumGift) {
      return this;
    }
    if (parseInt(values.BonusPremiumGift) !== parseInt(this.gift.val)) {
      return this;
    }
    this.isChecked = true;
    var parsedVariantOptionId = parseInt(values.BonusPremiumGiftVariantOptionId);
    this.selectedVariantOptionId = isNaN(parsedVariantOptionId) ? null : parsedVariantOptionId;
    this.render();
    return this.touch();
  },
  onBonusGiftToggled: function (e) {
    var toggleId = e.currentTarget.id;
    this.isChecked = !!e.currentTarget.checked;
    this.selectedVariantOptionId = null;
    this.render();
    this.clearFeedback();
    this.touch();
    $('#' + toggleId).focus();
    window.nvtag.trigger('bonusGiftChanged', { selected: this.isChecked, gift: this.gift });
  },
  onVariantSelected: function (e) {
    var val = e.currentTarget.value;
    this.selectedVariantOptionId = val ? parseInt(val) : null;
    this.clearVariantErrors();
    this.clearBackorderMessage();
    if (val) {
      var $selected = $(e.currentTarget).find('option:selected');
      if ($selected.data('availability') === 'Backordered') {
        $(e.currentTarget).after('<small class="gift-backorder-message">' + _.escape(this.resources.PrimaryResources.BackorderedMessage) + '</small>');
      }
    }
  },
  errors: function () {
    var errors = [];
    if (this.isChecked && this.hasVariants() && !this.selectedVariantOptionId) {
      errors.push(this.resources.PrimaryResources.PleaseSelectVariantOption);
    }

    errors = invokeCallbacks('alterErrors', {
      val: this.val(),
      field_name: this.field_name(),
      errors: errors,
      def: this.def
    }).errors;
    this.trigger(errors.length ? 'invalid' : 'valid');
    return _.map(errors, _.bind(this.toError, this));
  },
  renderFeedbackWithErrors: function (errors) {
    this.clearVariantErrors();
    if (errors.length) {
      this.renderVariantErrors();
    }
    return errors;
  },
  clearFeedback: function () {
    this.clearVariantErrors();
    return this;
  },
  clearVariantErrors: function () {
    this.$('.gift-variant-error').remove();
  },
  clearBackorderMessage: function () {
    this.$('.gift-backorder-message').remove();
  },
  renderVariantErrors: function () {
    var self = this;
    _.each(this.gift.variants, function (variant) {
      var $select = self.$('.bonus-gift-variant-select[data-variant-id="' + variant.id + '"]');
      if (!$select.val()) {
        var message = self.resources.fill(
            self.resources.PrimaryResources.SelectAVariantOptionToContinue, variant.name);
        $select.after('<small class="gift-variant-error" style="color: red; display: block;">' + _.escape(message) + '</small>');
      }
    });
  }
});
